import { ActivityIndicator } from 'react-native';
import { useTheme } from '@/lib/styling';
import { Theme } from '@/theme';
import { Box, Text } from '@/components/ui/primitives';
import { Button } from '@/components/ui/Button';

type LeagueLayoutStatusProps =
  | { state: 'loading' }
  | { state: 'not-found'; onReturnHome: () => void };

export default function LeagueLayoutStatus(props: LeagueLayoutStatusProps) {
  const theme = useTheme<Theme>();

  if (props.state === 'not-found') {
    return (
      <Box flex={1} backgroundColor="background">
        <Box flex={1} alignItems="center" justifyContent="center" padding="xl">
          <Text variant="h3" color="destructive" marginBottom="s">League Not Found</Text>
          <Text variant="body" color="textSecondary" textAlign="center" marginBottom="xl">
            We couldn{"'"}t load the league data. You may not have permission to view this league or it may no longer exist.
          </Text>
          <Button onPress={props.onReturnHome} variant="default">
            Return Home
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box flex={1} backgroundColor="background">
      <Box flex={1} alignItems="center" justifyContent="center">
        <ActivityIndicator size="large" color={theme.colors.press} />
        <Text variant="caption" color="pressMuted" marginTop="m">Loading league...</Text>
      </Box>
    </Box>
  );
}
